import { put } from 'redux-saga/effects';
import { DeviceAlive } from '../../Offline/offlineActions';
import { runPeriodicTaskSagaWhilePlatform } from '../../Saga/periodicTaskSaga';

export function* notifyDeviceStatus() {
	yield runPeriodicTaskSagaWhilePlatform(60e3, 60e3, function* (): IterableIterator<any> {
		yield put<DeviceAlive>({
			type: DeviceAlive,
		});
	});
}
